import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IdentityPlatformIcon } from '@/shared/ui/Icons';

import { FormSection, PersonaTextField } from '../../PersonaFormSections';
import { isFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

export function BasicInformationSection() {
  const { t } = useTranslation('audiences');

  const { control } = useEditPersonaFormContext();

  return (
    <FormSection
      icon={<IdentityPlatformIcon />}
      title={t('audiences.basicInformationSection.basicInformation')}
    >
      <div className="flex flex-col gap-6">
        <div className="grid grid-cols-2 gap-4">
          <Controller
            name="personaTitle"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <PersonaTextField
                {...field}
                label={t('audiences.basicInformationSection.title')}
                placeholder={t('audiences.basicInformationSection.eGBudgetSavvyStudent')}
                required={isFieldRequired(field.name)}
                error={error?.message}
              />
            )}
          />
          <Controller
            name="segment"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <PersonaTextField
                {...field}
                label={t('audiences.basicInformationSection.segment')}
                placeholder={t('audiences.basicInformationSection.eGEcoTechAspirers')}
                required={isFieldRequired(field.name)}
                error={error?.message}
              />
            )}
          />
        </div>

        <Controller
          name="quote"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <PersonaTextField
              {...field}
              label={t('audiences.basicInformationSection.quote')}
              placeholder={t('audiences.basicInformationSection.iWantProductsThatMatch')}
              multiline
              maxRows={8}
              required={isFieldRequired(field.name)}
              error={error?.message}
            />
          )}
        />
      </div>
    </FormSection>
  );
}
